import { render, staticRenderFns } from "./Scale.vue?vue&type=template&id=27f64d2e&lang=pug&"
import script from "./Scale.vue?vue&type=script&lang=js&"
export * from "./Scale.vue?vue&type=script&lang=js&"
import style0 from "./Scale.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports